import { SelectItem } from 'primeng/api';


export class Idioma implements SelectItem {
    label: string;
    value: any;
    styleClass?: string;
    icon: string;
	title: string;

	ENTIDAD: any;

	constructor(idioma){
		if (idioma) {
			this.label = idioma.Descripcion;
			this.value = idioma.Codigo;
			this.icon = idioma.Icono;
			this.title = idioma.Descripcion;

			this.ENTIDAD = idioma;
		}
	}

  }




// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/domain/Idioma.ts